import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { lt } from '@mews/framework';
import { LedgerActivityReportEntry } from '../components/mockData';

const columnHelper = createColumnHelper<LedgerActivityReportEntry>();

export const useLedgerActivityTableMapping = () => {
    return useMemo(
        () => [
            columnHelper.accessor('id', {
                header: () => lt('BillItem'),
            }),
            columnHelper.accessor('accounted', {
                header: () => lt('Consumed'),
            }),
            columnHelper.accessor('tax', {
                header: () => lt('Tax'),
            }),
            columnHelper.accessor('amount', {
                header: () => lt('Amount'),
                aggregationFn: 'sum',
            }),
        ],
        []
    );
};
